import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as BioJSUtil from 'biojs/Util';
import {Strand} from 'constants/MolbioConstants';
import * as sequtil from 'molbio/SeqUtil';
import {borderStyle} from 'molbio/SharedStyles';
import {LEGACY_FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import {BLUE, BLUE_LIGHT, GRAY_DARKER, ORANGE} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface CodonOptimizationTabSelectionHeaderProps {
  optimizationStart: number;
  optimizationEnd: number;
  seqLength: number;
  startIndex: number;
  onSetSelection: (start: number, end: number) => void;
  bases: string;
  strand: Strand;
  isOriginalSelection: boolean;
  isBackTranslation: boolean;
}

export const ORF_WARNING_TEXT = 'Region is not an ORF with a standard start codon';

export default function CodonOptimizationTabSelectionHeader(
  props: CodonOptimizationTabSelectionHeaderProps
): JSX.Element {
  const [selectionDisplayStart, selectionDisplayEnd] = sequtil.modelRangeToDisplay(
    props.optimizationStart,
    props.optimizationEnd,
    props.seqLength,
    props.startIndex
  );
  const strand = props.strand === 1 ? ' (Forward Strand)' : props.strand === -1 ? ' (Reverse Strand)' : '';
  const shouldShowORFWarning = !props.isBackTranslation && !BioJSUtil.isOrf(props.bases);
  return (
    <div className={css(styles.header)}>
      <span
        className={css(styles.selectionText)}
        onClick={() => {
          props.onSetSelection(props.optimizationStart, props.optimizationEnd);
        }}
      >{`Region: ${selectionDisplayStart}-${selectionDisplayEnd}${strand}`}</span>
      {shouldShowORFWarning && (
        <span className={css(styles.warning)}>
          <span className={css(styles.warningIcon)}>
            <BenchlingIcon icon="warning" />
          </span>
          <span className={css(styles.warningText)}>{ORF_WARNING_TEXT}</span>
        </span>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  header: {
    borderBottom: borderStyle,
    paddingBottom: '20px',
    fontSize: '14px',
    position: 'relative',
    height: 50,
  },
  selectionText: {
    color: BLUE_LIGHT,
    ':hover': {
      color: BLUE,
    },
    cursor: 'pointer',
    ...LEGACY_FONT_PROXIMA_TITLE,
  },
  warning: {
    float: 'right',
  },
  warningText: {
    color: GRAY_DARKER,
    fontWeight: 'bold',
  },
  warningIcon: {
    color: ORANGE,
    paddingLeft: 6,
    paddingRight: 6,
  },
});
